import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, computed, HostBinding, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';

export type EmptySize = '28' | '48' | '54' | '64' | '88';

@Component({
  selector: 'sky-empty',
  standalone: true,
  imports: [MatIconModule, TranslocoDirective],
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyComponent {
  scope = input.required<string>();
  fontIcon = input<string>('search_off');
  size = input<EmptySize>('48');
  minHeight = input<number | 'auto'>(320);
  hideIcon = input<boolean, BooleanInput>(false, {
    transform: coerceBooleanProperty,
  });

  hideHeader = input<boolean, BooleanInput>(false, {
    transform: coerceBooleanProperty,
  });

  hideSubHeader = input<boolean, BooleanInput>(false, {
    transform: coerceBooleanProperty,
  });

  iconSize = computed(() => {
    const size = Number.parseInt(this.size());
    return `${size / 2}`;
  });

  @HostBinding('style.min-height.px')
  get _minHeight() {
    return this.minHeight();
  }
}
